import PropTypes from "prop-types";
import { AddCircle, Close, Edit, Save } from "@mui/icons-material"
import { LoadingButton } from "@mui/lab";
import { CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, IconButton, MenuItem, Select, Tooltip } from "@mui/material";
import ArgonBox from "components/ArgonBox";
import ArgonButton from "components/ArgonButton"
import ArgonInput from "components/ArgonInput";
import ArgonTypography from "components/ArgonTypography";
import { postSubmit } from "global/postFunc";
import { postDataWithResponse } from "global/postFunc";
import { useEffect, useState } from "react";


const Tambah = ({
    decryptedUser,
    updating,
    setUpdating,
    addReq,
    editData
}) => {
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const [saving, setSaving] = useState(false)
    const [loading, setLoading] = useState(false)

    const [prevKdPd, setPrevKdPd] = useState('')
    const [bidangUrusan1, setBidangUrusan1] = useState('0.00');
    const [bidangUrusan2, setBidangUrusan2] = useState('0.00');
    const [bidangUrusan3, setBidangUrusan3] = useState('0.00');
    const [kdPd, setKdPd] = useState('')
    const [namaPd, setNamaPd] = useState('')
    const [alamat, setAlamat] = useState('')
    const [email, setEmail] = useState('')
    const [tlp, setTlp] = useState('')
    const [namaPimpinan, setNamaPimpinan] = useState('')
    const [nipPimpinan, setNipPimpinan] = useState('')
    const [jenis, setJenis] = useState('')

    const [listBidangUrusan, setListBidangUrusan] = useState([])

    const reqBidangUrusan = () => {
        setListBidangUrusan([])
        setLoading(true)
        addReq()
        postDataWithResponse(
            '/sa/kodefikasi-perencanaan/filter',
            {
                ket: 'BIDANG URUSAN'
            },
            decryptedUser,
            (res) => {
                setLoading(false)
                setListBidangUrusan(res)
            },
            (res) => {
                setLoading(false)
                setOpen(false)
            }
        );
    }

    useEffect(() => {
        if (open) {
            reqBidangUrusan()
            if (editData.isEnable) {
                console.log(editData.data);
                setPrevKdPd(editData.data.kd_pd)
                setBidangUrusan1(editData.data.kd_bidang_urusan_1)
                setBidangUrusan2(editData.data.kd_bidang_urusan_2)
                setBidangUrusan3(editData.data.kd_bidang_urusan_3)
                setKdPd(editData.data.pd)
                setNamaPd(editData.data.nama_pd)
                setAlamat(editData.data.alamat)
                setEmail(editData.data.email)
                setTlp(editData.data.tlp)
                setNamaPimpinan(editData.data.nama_pimpinan)
                setNipPimpinan(editData.data.nip_pimpinan)
                setJenis(editData.data.ket)
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open])

    const submit = (e) => {
        e.preventDefault();
        let url =  '/sa/opd/tambah'
        let formData = {
            kd_bidang_urusan_1: bidangUrusan1,
            kd_bidang_urusan_2: bidangUrusan2,
            kd_bidang_urusan_3: bidangUrusan3,
            pd: kdPd,
            kd_pd: bidangUrusan1 + '.' + bidangUrusan2 + '.' + bidangUrusan3 + '.' + kdPd,
            nama_pd: namaPd,
            alamat: alamat,
            email: email,
            tlp: tlp,
            nama_pimpinan: namaPimpinan,
            nip_pimpinan: nipPimpinan,
            ket: jenis
        };
        if (editData.isEnable) {
            url = '/sa/opd/update/' + prevKdPd;
            formData._method = 'PUT'
        }
        // console.log(formData);
        setSaving(true)
        postSubmit(
            url,
            formData,
            decryptedUser,
            (res) => {
                setSaving(false)
                setOpen(false)
                setUpdating(!updating)
            },
            (res) => {
                setSaving(false)
                // setOpen(false)
            }
        )
        console.log('submit');
    }

    return (
        <>
            {
                editData.isEnable ?
                    <Tooltip title="Edit">
                        <IconButton aria-label="edit" onClick={handleOpen} color="success">
                            <Edit />
                        </IconButton>
                    </Tooltip>
                    :
                    <ArgonButton
                        variant='outlined'
                        color="info"
                        size="small"
                        startIcon={<AddCircle />}
                        onClick={handleOpen}
                    >
                        Tambah Data
                    </ArgonButton>
            }
            <Dialog
                open={open}
                maxWidth="md"
                fullWidth
                // scroll='paper'
                p={3}
                component='form'
                onSubmit={submit}
            >
                <DialogTitle>
                    <ArgonTypography variant='body2' fontWeight="bold">Tambah Perangkat Daerah</ArgonTypography>
                </DialogTitle>
                <DialogContent p={3}>
                    <ArgonBox mb={1}>
                        <ArgonTypography component="label" variant="caption" fontWeight="bold">
                            {bidangUrusan1 + '.' + bidangUrusan2 + '.' + bidangUrusan3 + '.' + kdPd + ' ' + namaPd}
                        </ArgonTypography>
                    </ArgonBox>
                    <ArgonBox mb={1}>
                        <ArgonBox mb={1} ml={0.5}>
                            <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                Bidang Urusan 1
                            </ArgonTypography>
                        </ArgonBox>
                        <FormControl fullWidth>
                            {/* <InputLabel id="demo-simple-select-standard-label">Age</InputLabel> */}
                            <Select
                                placeholder="Select year"
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={bidangUrusan1}
                                onChange={(e) => {
                                    setBidangUrusan1(e.target.value)
                                }}
                                required
                                endAdornment={loading ? <CircularProgress color="inherit" size={20} /> : null}
                            >
                                <MenuItem key={0} value='0.00'>Pilih Bidang Urusan</MenuItem>
                                {
                                    listBidangUrusan.map((bu, index) => (
                                        <MenuItem key={index + 1} value={bu.kode}>{bu.uraian}</MenuItem>
                                    ))
                                }
                            </Select>
                        </FormControl>
                    </ArgonBox>
                    <ArgonBox mb={1}>
                        <ArgonBox mb={1} ml={0.5}>
                            <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                Bidang Urusan 2
                            </ArgonTypography>
                        </ArgonBox>
                        <FormControl fullWidth>
                            <Select
                                placeholder="Select year"
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={bidangUrusan2}
                                onChange={(e) => {
                                    setBidangUrusan2(e.target.value)
                                }}
                                required
                                endAdornment={loading ? <CircularProgress color="inherit" size={20} /> : null}
                            >
                                <MenuItem key={0} value='0.00'>Pilih Bidang Urusan</MenuItem>
                                {
                                    listBidangUrusan.map((bu, index) => (
                                        <MenuItem key={index + 1} value={bu.kode}>{bu.uraian}</MenuItem>
                                    ))
                                }
                            </Select>
                        </FormControl>
                    </ArgonBox>
                    <ArgonBox mb={1}>
                        <ArgonBox mb={1} ml={0.5}>
                            <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                Bidang Urusan 3
                            </ArgonTypography>
                        </ArgonBox>
                        <FormControl fullWidth>
                            <Select
                                placeholder="Select year"
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={bidangUrusan3}
                                onChange={(e) => {
                                    setBidangUrusan3(e.target.value)
                                }}
                                required
                                endAdornment={loading ? <CircularProgress color="inherit" size={20} /> : null}
                            >
                                <MenuItem key={0} value='0.00'>Pilih Bidang Urusan</MenuItem>
                                {
                                    listBidangUrusan.map((bu, index) => (
                                        <MenuItem key={index + 1} value={bu.kode}>{bu.uraian}</MenuItem>
                                    ))
                                }
                            </Select>
                        </FormControl>
                    </ArgonBox>
                    <ArgonBox mb={1}>
                        <ArgonBox mb={1} ml={0.5}>
                            <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                Kode Perangkat Daerah
                            </ArgonTypography>
                        </ArgonBox>
                        <ArgonInput
                            type="text"
                            required
                            size="medium"
                            value={kdPd}
                            onChange={(e) => setKdPd(e.target.value)}
                            autoComplete='off'
                        />
                    </ArgonBox>
                    <ArgonBox mb={1}>
                        <ArgonBox mb={1} ml={0.5}>
                            <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                Nama Perangkat Daerah
                            </ArgonTypography>
                        </ArgonBox>
                        <ArgonInput
                            type="text"
                            required
                            size="medium"
                            value={namaPd}
                            onChange={(e) => setNamaPd(e.target.value)}
                            autoComplete='off'
                        />
                    </ArgonBox>
                    <ArgonBox mb={1}>
                        <ArgonBox mb={1} ml={0.5}>
                            <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                Alamat
                            </ArgonTypography>
                        </ArgonBox>
                        <ArgonInput
                            type="text"
                            
                            size="medium"
                            value={alamat}
                            onChange={(e) => setAlamat(e.target.value)}
                            autoComplete='off'
                        />
                    </ArgonBox>
                    <ArgonBox mb={1}>
                        <ArgonBox mb={1} ml={0.5}>
                            <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                Email
                            </ArgonTypography>
                        </ArgonBox>
                        <ArgonInput
                            type="email"
                            
                            size="medium"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            autoComplete='off'
                        />
                    </ArgonBox>
                    <ArgonBox mb={1}>
                        <ArgonBox mb={1} ml={0.5}>
                            <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                Telp
                            </ArgonTypography>
                        </ArgonBox>
                        <ArgonInput
                            type="text"
                            
                            size="medium"
                            value={tlp}
                            onChange={(e) => setTlp(e.target.value)}
                            autoComplete='off'
                        />
                    </ArgonBox>
                    <ArgonBox mb={1}>
                        <ArgonBox mb={1} ml={0.5}>
                            <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                Nama Pimpinan
                            </ArgonTypography>
                        </ArgonBox>
                        <ArgonInput
                            type="text"
                            
                            size="medium"
                            value={namaPimpinan}
                            onChange={(e) => setNamaPimpinan(e.target.value)}
                            autoComplete='off'
                        />
                    </ArgonBox>
                    <ArgonBox mb={1}>
                        <ArgonBox mb={1} ml={0.5}>
                            <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                NIP Pimpinan
                            </ArgonTypography>
                        </ArgonBox>
                        <ArgonInput
                            type="text"
                            
                            size="medium"
                            value={nipPimpinan}
                            onChange={(e) => setNipPimpinan(e.target.value)}
                            autoComplete='off'
                        />
                    </ArgonBox>
                    <ArgonBox mb={1}>
                        <ArgonBox mb={1} ml={0.5}>
                            <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                Jenis
                            </ArgonTypography>
                        </ArgonBox>
                        <FormControl fullWidth>
                            {/* <InputLabel id="demo-simple-select-standard-label">Age</InputLabel> */}
                            <Select
                                placeholder="Select year"
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={jenis}
                                onChange={(e) => {
                                    setJenis(e.target.value)
                                }}
                                required
                            >
                                <MenuItem key={0} value='opd'>DINAS</MenuItem>
                                <MenuItem key={1} value='kecamatan'>KECAMATAN</MenuItem>
                            </Select>
                        </FormControl>
                    </ArgonBox>
                </DialogContent>
                <DialogActions>
                    <Grid container spacing={2} justifyContent='flex-end' px={2} mb={2}>
                        <Grid item>
                            <ArgonButton color='info' variant='outlined' size="small" startIcon={<Close />} onClick={handleClose}>Batal</ArgonButton>
                        </Grid>
                        <Grid item>
                            <LoadingButton color='info' variant='contained' size="small" startIcon={<Save />} type='submit' loading={saving}>Simpan</LoadingButton>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
        </>
    )
}

Tambah.defaultProps = {
    editData: {
        isEnable: false
    }
};

Tambah.prototype = {
    decryptedUser: PropTypes.string.isRequired,
    updating: PropTypes.bool.isRequired,
    setUpdating: PropTypes.func.isRequired,
    addReq: PropTypes.func.isRequired,
    editData: PropTypes.shape({
        isEnable: PropTypes.bool.isRequired,
        data: PropTypes.object
    })
}

export default Tambah